import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "./i18n";
import { captureLinkKey } from "./lib/linkKey";
import "./styles.css";

// Before the first render, and before anything else could read the URL: the
// fragment is the decryption key, and it should not be in `location.href`
// for any longer than it takes to get it out. See lib/linkKey.ts.
captureLinkKey();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
